import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: calc(100% - 107px);
  background: var(--white);
  padding: 0 3%;
  overflow: auto;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    h1 {
      color: var(--blueDark);
    }

    > div {
      display: flex;
      flex-direction: column;
      text-align: right;
      font-weight: 500;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  img {
    width: 100%;
  }

  button {
    background: var(--yellowDark);
    color: var(--blueDark);
    border-radius: 10px;
    padding: 5px 10px;
    margin-top: 30px;
    margin-bottom: 15px;
    font-weight: bold;
    box-shadow: 2px 2px 2px rgba(12, 13, 14, 0.15);
    transition: background 0.2s;
  }

  button:hover {
    background: ${darken(0.06, '#f7c325')};
  }
`;
